import { defineAction } from '~/prix'
import { z } from 'zod'
import semenProgramUpdateAction from './semenProgramUpdate.action.json' with { type: 'json' }
import { semenProgramObject } from '../semenProgramObject'

const semenProgramUpdateDefinition = defineAction({
  ...semenProgramUpdateAction,

  input: semenProgramObject
    .pick({ id: true, name: true, usageLimit: true, description: true, bullId: true })
    .partial()
    .required({ id: true }),
  output: z.object({}),
})

export default semenProgramUpdateDefinition
